import { CollapsibleItem, CollapsiblePositionBaseValue } from '@addins/core/singlecallcard';

export class SagaFormsCollapsibleItem extends CollapsibleItem {
  constructor() {
    super('Mobile.Forms.GroupName', 'SagaForms/CallcardForms', CollapsiblePositionBaseValue.SagaForms);
  }
}
